import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AimsAuthKey, SessionService} from '../@core/session.service';
import {ActivatedRoute} from "@angular/router";
import {NzSkeletonModule} from "ng-zorro-antd/skeleton";


@Component({
  selector: 'app-signon',
  standalone: true,
  imports: [CommonModule, NzSkeletonModule],
  template: `
    <nz-skeleton></nz-skeleton>
  `,
  styles: []
})
export class SignonComponent implements OnInit {

  constructor(private route: ActivatedRoute, private sess: SessionService) {
  }

  ngOnInit(): void {
    const token = this.route.snapshot.paramMap.get('token')! ?? sessionStorage.getItem(AimsAuthKey)!;
    this.sess.initJwt(token).then();
  }
}
